import { Label } from "reactstrap"
import InputField from "./InputField"

const FormInputField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  error,
  ...props
}) => (
  <>
    <Label htmlFor={name}>{label}</Label>
    <InputField
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      invalid={error}
      {...props}
    />
    {error && <div className="text-danger small">{error}</div>}
  </>
)

export default FormInputField
